// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1JwLI","head":"Table_head__1RtLQ","col":"Table_col__1seb5"};